import { render, staticRenderFns } from "./NotificationDeviceSettings.vue?vue&type=template&id=f72a5b28&scoped=true&"
import script from "./NotificationDeviceSettings.vue?vue&type=script&lang=js&"
export * from "./NotificationDeviceSettings.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDeviceSettings.vue?vue&type=style&index=0&id=f72a5b28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72a5b28",
  null
  
)

export default component.exports